import { InjectionToken } from '@angular/core';
import type { AuthenticationOptions } from 'azure-maps-control';

export const MAP_AUTH_OPTIONS = new InjectionToken<AuthenticationOptions>(
  'MAP_AUTH_OPTIONS',
);
